import kamala from '../../kamala'
import Modal from './Modal'

Modal.install = function (Vue) {
  kamala(Vue)

  Vue.component(Modal.name, Modal)
}

export default Modal
